import { QueryClient } from "react-query";
import { ApiError } from "./backend";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // TODO: queries still retries on focus if apierror
      retry: (failureCount, error) => {
        if (error instanceof ApiError) return false;
        if (failureCount <= 3) return true;
        return false;
      },
      behavior: {
        onFetch: (ctx) => {},
      },
    },
  },
});

export default queryClient;
